// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  orderRowId: __t.string().name("order_row_id"),
  playerId: __t.string().name("player_id"),
  matchId: __t.string().name("match_id"),
  unitId: __t.string().name("unit_id"),
  ordinal: __t.u32(),
  orderType: __t.string().name("order_type"),
  targetX: __t.option(__t.f64()).name("target_x"),
  targetY: __t.option(__t.f64()).name("target_y"),
  facing: __t.option(__t.f64()),
  targetUnitId: __t.option(__t.string()).name("target_unit_id"),
});
